import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { RequestManagementService } from '../services/request-management.service';
import 'rxjs/add/operator/map';
import {
    UserModel, ConfirmPasswordRequest,
    ConfirmPasswordModel, AuthenticateResponse, ChangePasswordRequest
} from '../_models/_index';


@Injectable()
export class UserService {

    constructor(private requestManagement: RequestManagementService) {        
    }

    public authenticate(user: UserModel): Promise<AuthenticateResponse> {                
        return this.requestManagement.callPostRequest('users/authenticate', user)
            .map((response: Response) => {

            //let user: UserModel = <UserModel>response.json();
            //localStorage.setItem('currentUser', JSON.stringify(user));
                return <AuthenticateResponse>response.json();;
        }).toPromise();
    }

    public getUser(user: UserModel): Promise<UserModel> {
        return this.requestManagement.callPostRequest('users/getUser', user)
            .map((response: Response) => {

                let user: UserModel = <UserModel>response.json();
                localStorage.setItem('currentUser', JSON.stringify(user));
                return <UserModel>response.json();;
            }).toPromise();
    }
   

    public sendCodeOnLogin(user: UserModel): Promise<UserModel> {
        return this.requestManagement.callPostRequest('users/sendCodeOnLogin', user).map((response: Response) => {
            return <UserModel>response.json();
        }).toPromise();
    }

    public forgotPassword(user: UserModel): Promise<UserModel> {
        return this.requestManagement.callPostRequest('users/forgotPassword', user).map((response: Response) => {
            return <UserModel>response.json();
        }).toPromise();
    }

    public changePassword(request: ChangePasswordRequest): Promise<UserModel> {
        return this.requestManagement.callPostRequest('users/changePassword', request).map((response: Response) => {
            let user: UserModel = <UserModel>response.json();
            localStorage.setItem('currentUser', JSON.stringify(user));
            return <UserModel>response.json();
        }).toPromise();
    }

    public confirmTempRestorePassword(request: ConfirmPasswordRequest): Promise<ConfirmPasswordModel> {
        return this.requestManagement.callPostRequest('users/confirmTempRestorePassword', request).map((response: Response) => {
            return <ConfirmPasswordModel>response.json();
        }).toPromise();
    }


    public confirmPassword(request: ConfirmPasswordRequest): Promise<ConfirmPasswordModel> {
        return this.requestManagement.callPostRequest('users/confirmPassword', request).map((response: Response) => {
            return <ConfirmPasswordModel>response.json();
        }).toPromise();
    }

    public decryptPassword(user:UserModel): Promise<string> {
        return this.requestManagement.callPostRequest('users/decryptPassword', user ).map((response: Response) => {
            return <string>response.json();
        }).toPromise();
    }


    public isUserLoggedIn(): boolean {
        if (localStorage.getItem('currentUser')) {
            return true;
        }

        return false;
    }

    public isRepresentative() {
        return this.isUserLoggedIn();
    }

    public isCustomer() {
        return !this.isUserLoggedIn();
    }

    public logout(): void {
        localStorage.removeItem('currentUser');
    }

    public getCurrentUser(): UserModel {
        return <UserModel>JSON.parse(localStorage.getItem('currentUser'));
    }

    public getUsers(): Promise<UserModel[]> {
        return this.requestManagement.callGetRequest('users/get',null).map((response: Response) => {
            return <UserModel[]>response.json();
        }).toPromise();
    }  

    public addUser(user: UserModel): Promise<UserModel> {        
        user.creatorID = this.getCurrentUser().id;
        return this.requestManagement.callPostRequest('users/add', user).map((response: Response) => {
            return <UserModel>response.json();
        }).toPromise();
    }

    public editUser(user: UserModel): Promise<UserModel> {        
        user.updatorID = this.getCurrentUser().id;
        return this.requestManagement.callPostRequest('users/edit', user).map((response: Response) => {
            return <UserModel>response.json();
        }).toPromise();
    }

    public removeUser(user: UserModel): Promise<UserModel> {
        user.updatorID = this.getCurrentUser().id;
        return this.requestManagement.callPostRequest('users/remove', user).map((response: Response) => {
            return <UserModel>response.json();
        }).toPromise();
    }

    public checkUnique(user: UserModel): Promise<boolean> {
        return this.requestManagement.callPostRequest('users/checkUnique', user).map((response: Response) => {
            return <boolean>response.json();
        }).toPromise();
    }

    public unBlockUser(userID: number): Promise<UserModel> {
        return this.requestManagement.callPostRequest('users/unBlockUser', { 'UserID': userID }).map((response: Response) => {
            return <UserModel>response.json();
        }).toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts